import VideoBanner from "../components/VideoBanner";
import VideoPlayer from "../components/VideoPlayer";
import VideoSelector from "../components/VideoSelector";
import { useState } from "react";

export default function Video() {
  const [bannerEnabled, setBannerEnabled] = useState(true)
  
  // Hardcoded YouTube videos (previously fetched from Strapi CMS)
  const videoOptions = [
    { value: "https://www.youtube.com/watch?v=OS9fluEaqrY", label: "Echo Party (Official Music Video)" },
    { value: "https://www.youtube.com/watch?v=QauTyt8VDOY", label: "Didn't Care (Official Audio)" },
    { value: "https://www.youtube.com/watch?v=2jAuIf6iZMw", label: "Your Reality (Official Audio)" },
    { value: "https://www.youtube.com/watch?v=7LLXffiUoGU", label: "Sunburn (Official Audio)" },
    { value: "https://www.youtube.com/watch?v=CImTAza83fQ", label: "SE x Historic Durham Athletic Park" }
  ];
  
  const [videoSource, setVideoSource] = useState(videoOptions[0].value)
  const listReady = 1;

  return (
    <div>
      <VideoBanner page="video" bannerEnabled={bannerEnabled} />
      <VideoPlayer videoSource={videoSource} setBannerEnabled={setBannerEnabled} />
      <VideoSelector videoOptions={videoOptions} listReady={listReady} setVideoSource={setVideoSource} />
    </div>
  );
}